var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-info"},[_vm._v(_vm._s(_vm.$t('QUESTION_FORM.NOT_VOTED')))])
}
var staticRenderFns = []

export { render, staticRenderFns }